import { t, tf } from "./i18n.js";
// ==========================================
// ONLINE-STATUS LOGIK (Presence)
// ==========================================

window.onlineUserIds = new Set();
window.presenceChannel = null;

async function initPresence() {
  if (!currentUser || isGuest) return;

  // Kontowechsel: alter In-Memory-Freundescache gehoert nicht zum neuen
  // Nutzer (der localStorage-Schluessel ist ohnehin je Nutzer-ID getrennt)
  friendsCache = null;

  // Bestehenden Channel sicherheitshalber bereinigen
  if (presenceChannel) {
    _supabase.removeChannel(presenceChannel);
  }

  presenceChannel = _supabase.channel("online-users");

  presenceChannel
    .on("presence", { event: "sync" }, () => {
      const newState = presenceChannel.presenceState();
      updateOnlineUsers(newState);
    })
    .on("presence", { event: "join" }, ({ key, newPresences }) => {
      newPresences.forEach((p) => onlineUserIds.add(p.user_id));
      refreshFriendsUIIfOpen();
    })
    .on("presence", { event: "leave" }, ({ key, leftPresences }) => {
      leftPresences.forEach((p) => onlineUserIds.delete(p.user_id));
      refreshFriendsUIIfOpen();
    })
    .subscribe(async (status) => {
      if (status === "SUBSCRIBED") {
        // Meldet den aktuellen User als "online" im Channel an
        await presenceChannel.track({
          user_id: currentUser.id,
          online_at: new Date().toISOString(),
        });
      }
    });
}

function updateOnlineUsers(state) {
  onlineUserIds.clear();
  for (const id in state) {
    state[id].forEach((presence) => {
      onlineUserIds.add(presence.user_id);
    });
  }
  refreshFriendsUIIfOpen();
}

// Umbau: Die Freundesliste ist kein Modal mehr, sondern eine einklappbare
// Sidebar rechts im Hauptmenue (home-friends-panel). Eingeklappt bleibt
// eine schmale Schiene mit gedrehtem Titel und Online-Punkt stehen;
// aufgeklappt erscheint das volle Panel. "Offen" heisst jetzt:
// Home-Screen sichtbar - Zusammenfassung und Punkt werden auch im
// eingeklappten Zustand aktuell gehalten.
function refreshFriendsUIIfOpen() {
  // Der Dock haengt nicht mehr am home-screen, sondern nur an der eigenen
  // Sichtbarkeit (app.js blendet ihn bei Login ein / auf Auth aus).
  const dock = document.getElementById("home-friends-panel");
  if (!dock || dock.style.display === "none") return;
  if (isGuest || !currentUser) return;
  // Presence-Wechsel (online/offline) brauchen keinen DB-Roundtrip:
  // der Status steckt in onlineUserIds, es reicht neu zu zeichnen.
  if (friendsCache) {
    renderFriendsData(friendsCache.relations, friendsCache.profilesMap || {});
  } else {
    fetchAndRenderFriends();
  }
}

const FRIENDS_PANEL_KEY = "secure-darts:friends-panel-open";

function toggleFriendsPanel(forceOpen = null) {
  const panel = document.getElementById("home-friends-panel");
  const body = document.getElementById("friends-panel-body");
  if (!panel || !body) return;

  const open =
    forceOpen !== null ? forceOpen : panel.classList.contains("collapsed");
  panel.classList.toggle("collapsed", !open);
  body.style.display = open ? "block" : "none";

  const chevron = document.getElementById("friends-chevron");
  if (chevron) chevron.textContent = open ? "▸" : "◂";
  const head = document.querySelector("#home-friends-panel .home-friends-head");
  if (head) head.setAttribute("aria-expanded", open ? "true" : "false");

  try {
    localStorage.setItem(FRIENDS_PANEL_KEY, open ? "1" : "0");
  } catch (e) {
    // Privater Modus - der Zustand gilt dann nur fuer diese Sitzung
  }

  if (open) fetchAndRenderFriends();
}

// Zentraler Einstieg fuer goHome(): stellt den gemerkten Auf-/Zu-Zustand
// wieder her und haelt die Zusammenfassung in der Kopfzeile aktuell.
// fetchAndRenderFriends bringt die Gast-/Null-Absicherung selbst mit.
function refreshHomeFriendsPanel() {
  let stored = null;
  try {
    stored = localStorage.getItem(FRIENDS_PANEL_KEY);
  } catch (e) {
    stored = null;
  }
  if (stored === "1") {
    toggleFriendsPanel(true); // ruft fetchAndRenderFriends selbst auf
  } else {
    fetchAndRenderFriends(); // eingeklappt: nur Badge + Zusammenfassung
  }
}

// ==========================================
// FREUNDES-SYSTEM LOGIK
// ==========================================

let currentFriendsTab = "list";

// Wechselt zwischen "Meine Freunde" und "Anfragen"
function switchFriendsTab(tab) {
  currentFriendsTab = tab;

  const btnList = document.getElementById("tab-friends-list");
  const btnReq = document.getElementById("tab-friends-req");

  if (tab === "list") {
    btnList.style.background = "var(--accent-blue)";
    btnList.style.color = "white";
    btnReq.style.background = "#333";
    btnReq.style.color = "#aaa";
  } else {
    btnReq.style.background = "var(--accent-blue)";
    btnReq.style.color = "white";
    btnList.style.background = "#333";
    btnList.style.color = "#aaa";
  }

  fetchAndRenderFriends(); // Liste neu zeichnen
}

// 1. Freundschaftsanfrage senden
// 1. Spieler in der Datenbank suchen und als Liste anzeigen
async function searchPlayers() {
  const input = document.getElementById("friend-search-input");
  const searchName = input.value.trim();
  const resultsContainer = document.getElementById("friend-search-results");

  if (!searchName) {
    resultsContainer.innerHTML = "";
    return;
  }

  resultsContainer.innerHTML = `<div style="color: #888; font-size: 0.9em; text-align: center; padding: 10px;">${t("js.friends.006")}</div>`;

  // Finde ALLE Spieler, in deren Namen der Suchbegriff vorkommt
  const { data: profiles, error } = await _supabase
    .from("profiles")
    .select("id, name, avatar_url")
    .ilike("name", `%${searchName}%`)
    .limit(10); // Wir cappen bei 10 Ergebnissen, damit es nicht überläuft

  if (error || !profiles || profiles.length === 0) {
    resultsContainer.innerHTML = `<div style="color: var(--accent-red); font-size: 0.9em; text-align: center; padding: 10px;">${t("js.friends.016")}</div>`;
    return;
  }

  let html = "";
  profiles.forEach((p) => {
    // Sich selbst aus den Suchergebnissen filtern
    if (p.id === currentUser.id) return;

    let avatar =
      p.avatar_url ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${p.name}`;

    html += `
      <div style="display: flex; justify-content: space-between; align-items: center; background: #222; padding: 8px 12px; border-radius: 8px; margin-top: 5px; border: 1px solid #333;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <img alt="" src="${avatar}" style="width: 32px; height: 32px; border-radius: 50%; background: #111; object-fit: cover;">
          <span style="color: white; font-weight: bold;">${p.name}</span>
        </div>
        <button onclick="sendFriendRequestById('${p.id}', '${p.name}')" style="background: var(--accent-green); color: black; border: none; border-radius: 6px; padding: 6px 12px; font-weight: bold; cursor: pointer; font-size: 0.85em;">Hinzufügen</button>
      </div>
    `;
  });

  if (html === "") {
    html = `<div style="color: #888; font-size: 0.9em; text-align: center; padding: 10px;">${t("js.friends.017")}</div>`;
  }

  resultsContainer.innerHTML = html;
}

// 1b. Anfrage gezielt über die ID senden
async function sendFriendRequestById(targetId, targetName) {
  const { error: insertErr } = await _supabase
    .from("friends")
    .insert([
      { sender_id: currentUser.id, receiver_id: targetId, status: "pending" },
    ]);

  if (insertErr) {
    if (insertErr.code === "23505") {
      showToast(
        t("js.friends.001"),
        "error"
      );
    } else {
      showToast(t("js.friends.002") + insertErr.message, "error");
    }
  } else {
    showToast(tf("js.friends.007", { p1: targetName }), "success");
    // Suchfeld und Ergebnisse nach erfolgreicher Anfrage leeren
    document.getElementById("friend-search-input").value = "";
    document.getElementById("friend-search-results").innerHTML = "";

    fetchAndRenderFriends(); // Tab-Ansicht aktualisieren
  }
}

// 2. Freunde und Anfragen aus der DB laden
// -----------------------------------------------------------------
// LADEZEIT: Stale-while-revalidate
//
// Supabase-Roundtrips dauern spuerbar (2 Abfragen nacheinander). Deshalb
// wird der letzte Stand (Beziehungen + Profile) im Speicher und in
// localStorage gehalten: Beim Oeffnen zeichnet die Liste SOFORT aus dem
// Cache und aktualisiert sich im Hintergrund. Presence-Wechsel (online/
// offline) brauchen gar keinen Roundtrip - der Status steckt lokal in
// onlineUserIds, es wird nur neu gezeichnet.
// -----------------------------------------------------------------
let friendsCache = null; // { relations, profilesMap }

function friendsCacheKey() {
  return currentUser ? `secure-darts:friends-cache:${currentUser.id}` : null;
}

function readFriendsCacheFromStorage() {
  try {
    const raw = localStorage.getItem(friendsCacheKey());
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && Array.isArray(parsed.relations) ? parsed : null;
  } catch (e) {
    return null;
  }
}

async function fetchAndRenderFriends() {
  const container = document.getElementById("friends-list-container");
  if (!container) return;

  // Das Panel steht dauerhaft im Hauptmenue - auch Gaeste sehen es.
  // Ohne Login gibt es keine Freundesdaten, dafuer einen klaren Hinweis.
  if (isGuest || !currentUser) {
    container.innerHTML = `<div style="text-align:center; color:var(--text-muted); padding:20px;">${t("js.friends.018")}</div>`;
    const guestSummary = document.getElementById("friends-summary");
    if (guestSummary) guestSummary.textContent = t("js.friends.020");
    return;
  }

  // 1) Sofort zeichnen, was da ist - erst danach frisch laden
  if (!friendsCache) friendsCache = readFriendsCacheFromStorage();
  if (friendsCache) {
    renderFriendsData(friendsCache.relations, friendsCache.profilesMap || {});
  } else {
    container.innerHTML = `<div style="text-align:center; color:#888; padding:20px;">${t("js.stats.005")}</div>`;
  }

  // 2) Holt alle Beziehungen, an denen ich beteiligt bin (Sender oder Empfänger)
  const { data: relations, error } = await _supabase
    .from("friends")
    .select("*")
    .or(`sender_id.eq.${currentUser.id},receiver_id.eq.${currentUser.id}`);

  if (error) {
    // Mit Cache: alter Stand bleibt stehen statt einer Fehlermeldung
    if (!friendsCache) {
      container.innerHTML = `<div style="color:var(--accent-red); padding:10px;">${tf("js.friends.008", { p1: error.message })}</div>`;
    }
    return;
  }

  // IDs aller beteiligten User sammeln, um deren Namen/Avatare zu holen
  let userIdsToFetch = new Set();
  relations.forEach((r) => {
    userIdsToFetch.add(
      r.sender_id === currentUser.id ? r.receiver_id : r.sender_id
    );
  });

  let profilesMap = {};
  if (userIdsToFetch.size > 0) {
    const { data: profiles } = await _supabase
      .from("profiles")
      .select("id, name, avatar_url")
      .in("id", Array.from(userIdsToFetch));

    if (profiles) {
      profiles.forEach((p) => (profilesMap[p.id] = p));
    }
  }

  friendsCache = { relations: relations, profilesMap: profilesMap };
  try {
    localStorage.setItem(friendsCacheKey(), JSON.stringify(friendsCache));
  } catch (e) {
    // Voller/gesperrter Speicher - dann eben nur der In-Memory-Cache
  }

  renderFriendsData(relations, profilesMap);
}

// Reines Zeichnen (kein Netzwerk) - nutzbar aus Cache und Presence-Events
function renderFriendsData(relations, profilesMap) {
  const container = document.getElementById("friends-list-container");
  if (!container) return;

  // Daten sortieren
  const pendingIncoming = relations.filter(
    (r) => r.status === "pending" && r.receiver_id === currentUser.id
  );
  const pendingOutgoing = relations.filter(
    (r) => r.status === "pending" && r.sender_id === currentUser.id
  );
  const accepted = relations.filter((r) => r.status === "accepted");

  // Rotes Badge für offene Anfragen updaten
  const badge = document.getElementById("req-badge");
  if (badge) {
    if (pendingIncoming.length > 0) {
      badge.style.display = "inline-block";
      badge.innerText = pendingIncoming.length;
    } else {
      badge.style.display = "none";
    }
  }

  // Zusammenfassung in der eingeklappten Kopfzeile: "2 online · 1 Anfrage"
  const summary = document.getElementById("friends-summary");
  if (summary) {
    const onlineFriendCount = accepted.filter((r) =>
      onlineUserIds.has(
        r.sender_id === currentUser.id ? r.receiver_id : r.sender_id,
      ),
    ).length;
    const parts = [tf("js.friends.034", { p1: onlineFriendCount })];
    if (pendingIncoming.length > 0) {
      parts.push(
        tf(pendingIncoming.length === 1 ? "js.friends.anfrage1" : "js.friends.anfrageN", {
          p1: pendingIncoming.length,
        }),
      );
    }
    summary.textContent = parts.join(" · ");
  }

  // Gruener Punkt auf der eingeklappten Schiene, wenn Freunde online sind
  const dot = document.getElementById("friends-online-dot");
  if (dot) {
    const anyOnline = accepted.some((r) =>
      onlineUserIds.has(
        r.sender_id === currentUser.id ? r.receiver_id : r.sender_id,
      ),
    );
    dot.style.display = anyOnline ? "" : "none";
  }

  // 3. UI Rendern basierend auf aktivem Tab
  let html = "";

  if (currentFriendsTab === "list") {
    if (accepted.length === 0) {
      html = `<div style="text-align:center; color:#888; padding:20px;">${t("js.friends.019")}</div>`;
    } else {
      accepted.forEach((rel) => {
        let friendId =
          rel.sender_id === currentUser.id ? rel.receiver_id : rel.sender_id;
        let friendProf = profilesMap[friendId] || {
          name: t("js.friends.021"),
          avatar_url: `https://api.dicebear.com/7.x/avataaars/svg?seed=${friendId}`,
        };

        // --- NEU: Online Status prüfen & Farben setzen ---
        let isOnline = onlineUserIds.has(friendId);
        let statusColor = isOnline
          ? "var(--accent-green)"
          : "var(--text-muted)";
        let statusFill = isOnline ? "var(--accent-green)" : "none";
        let statusText = isOnline ? t("js.friends.022") : t("js.friends.023");

        html += `
          <div style="display:flex; justify-content:space-between; align-items:center; background:var(--glass-bg); padding:10px; border-radius:8px; margin-bottom:8px; border:1px solid var(--glass-border);">
            <div style="display:flex; align-items:center; gap:10px;">
              <img alt="" src="${
                friendProf.avatar_url
              }" style="width:40px; height:40px; border-radius:50%; background:#111; object-fit:cover;">
              <div>
                <div
                  class="clickable-friend-name"
                  onclick="openFriendStats('${friendId}', '${encodeURIComponent(
                    friendProf.name
                  )}', '${encodeURIComponent(friendProf.avatar_url || "")}')"
                    >
                    ${friendProf.name}
                    </div>
                <div style="font-size:0.8em; color:${statusColor}; display:flex; align-items:center; gap:4px;">
                  <svg width="8" height="8" viewBox="0 0 12 12"><circle cx="6" cy="6" r="4" fill="${statusFill}" stroke="currentColor" stroke-width="2"/></svg> ${statusText}
                </div> 
              </div>
            </div>
            <div style="display:flex; gap:8px;">
              <button onclick="openChallengeSetup('${friendId}', '${
          friendProf.name
        }')" style="background:var(--accent); color:white; border:none; border-radius:6px; padding:6px 12px; cursor:pointer; font-weight:bold; display:flex; align-items:center; gap:5px;">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg> Spielen
                </button>
              <button onclick="removeFriend('${
                rel.id
              }')" style="background:transparent; color:var(--text-muted); border:1px solid var(--glass-border); border-radius:6px; padding:6px 10px; cursor:pointer; display:flex; align-items:center; justify-content:center;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
              </button>
            </div>
          </div>
        `;
      });
    }
  } else if (currentFriendsTab === "requests") {
    html += `<h4 style="color:#aaa; margin-bottom:10px;">Erhaltene Anfragen (${pendingIncoming.length})</h4>`;
    if (pendingIncoming.length === 0)
      html += `<div style="color:#666; font-size:0.9em; margin-bottom:20px;">${t("js.friends.009")}</div>`;

    pendingIncoming.forEach((rel) => {
      let friendProf = profilesMap[rel.sender_id] || { name: t("js.friends.021") };
      html += `
        <div style="display:flex; justify-content:space-between; align-items:center; background:#2a2a2a; padding:10px; border-radius:8px; margin-bottom:8px; border-left:3px solid var(--accent-blue);">
          <span style="color:white; font-weight:bold;">${friendProf.name}</span>
          <div>
            <button onclick="respondToRequest('${rel.id}', 'accepted')" style="background:var(--accent-green); color:black; border:none; border-radius:6px; padding:6px 12px; font-weight:bold; cursor:pointer; margin-right:5px;">Annehmen</button>
            <button onclick="removeFriend('${rel.id}')" style="background:transparent; color:#ff5252; border:1px solid #ff5252; border-radius:6px; padding:6px 12px; cursor:pointer;">Ablehnen</button>
          </div>
        </div>
      `;
    });

    html += `<h4 style="color:#aaa; margin-top:20px; margin-bottom:10px;">Gesendete Anfragen (${pendingOutgoing.length})</h4>`;
    pendingOutgoing.forEach((rel) => {
      let friendProf = profilesMap[rel.receiver_id] || { name: t("js.friends.021") };
      html += `
        <div style="display:flex; justify-content:space-between; align-items:center; background:#1a1a1a; padding:10px; border-radius:8px; margin-bottom:8px;">
          <span style="color:#888;">Warte auf ${friendProf.name}...</span>
          <button onclick="removeFriend('${rel.id}')" style="background:transparent; color:var(--text-muted); border:none; cursor:pointer; display:flex; align-items:center; gap:5px;">
            Abbrechen <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
      `;
    });
  }

  container.innerHTML = html;
}

// 4. Anfrage annehmen
async function respondToRequest(relationId, newStatus) {
  const { error } = await _supabase
    .from("friends")
    .update({ status: newStatus })
    .eq("id", relationId);

  // Die Spalte friends.status erlaubt per CHECK nur 'pending' und 'accepted'.
  // Ein Fehler wurde hier vorher stillschweigend verschluckt.
  if (error) {
    showToast(t("js.friends.003") + error.message, "error");
    return;
  }
  showToast(t("js.friends.024"), "success");
  fetchAndRenderFriends();
}

// 5. Freund löschen oder Anfrage ablehnen/abbrechen
async function removeFriend(relationId) {
  // FIX: confirm() war der letzte blockierende Browser-Dialog in der App.
  // showConfirmModal stammt aus ui.js und passt zum restlichen Design.
  showConfirmModal(t("js.friends.025"), async () => {
    const { error } = await _supabase
      .from("friends")
      .delete()
      .eq("id", relationId);

    if (error) {
      showToast(t("js.friends.004") + error.message, "error");
      return;
    }
    showToast(t("js.friends.026"), "success");
    fetchAndRenderFriends();
  });
}

let notificationChannel = null;

// Wird aufgerufen, sobald der User eingeloggt ist (am besten am Ende von initAuth)
function initNotifications() {
  if (!currentUser || isGuest) return;

  if (notificationChannel) _supabase.removeChannel(notificationChannel);

  // Jeder User lauscht auf seinem EIGENEN Kanal
  notificationChannel = _supabase.channel(`user-${currentUser.id}`);

  notificationChannel
    .on("broadcast", { event: "game-challenge" }, (payload) => {
      handleIncomingChallenge(payload.payload);
    })
    .on("broadcast", { event: "challenge-declined" }, (payload) => {
      if (typeof showToast === "function") {
        showToast(tf("js.friends.010", { p1: payload.payload.declinerName }), "error");
      } else {
        showToast(tf("js.friends.010", { p1: payload.payload.declinerName }), "info");
      }
      // Wenn wir in der Lobby warten, brechen wir diese ab
      if (currentAppMode === "501" && isOnlineHost) {
        cancelLobby();
      }
    })
    .subscribe();
}

// 1. Der Sender klickt auf "Spielen"
let currentChallengeTargetId = null;
let currentChallengeTargetName = null;

function openChallengeSetup(targetUserId, targetUserName) {
  currentChallengeTargetId = targetUserId;
  currentChallengeTargetName = targetUserName;

  document.getElementById("challenge-target-name").innerText = targetUserName;
  document.getElementById("challenge-setup-modal").style.display = "flex";

  // Dem "Start"-Button im Menü seine Aufgabe geben
  document.getElementById("btn-execute-challenge").onclick = () => {
    const mode = document.getElementById("challenge-mode-select").value;
    const legs = document.getElementById("challenge-legs-select").value;
    executeChallenge(
      targetUserId,
      targetUserName,
      mode,
      parseInt(legs),
      parseInt(mode)
    );
  };
}

async function executeChallenge(
  targetUserId,
  targetUserName,
  mode,
  legs,
  startScore
) {
  // 1. Setup-Modal ausblenden (die Freundesliste ist kein Modal mehr)
  document.getElementById("challenge-setup-modal").style.display = "none";

  // 2. RoomCode & Daten vorbereiten
  const roomCode = Math.floor(1000 + Math.random() * 9000).toString();
  myOnlineName =
    currentUser.user_metadata?.display_name || currentUser.email.split("@")[0];

  // ---> NEU: Zombie-Räume aufräumen! <---
  // Löscht alle Lobbies, bei denen du Host bist und die noch im Status "waiting" feststecken
  await _supabase
    .from("live_matches")
    .delete()
    .eq("player1_name", myOnlineName)
    .eq("status", "waiting");

  // 3. Lobby eröffnen & die ausgewählten LEGS in der Datenbank speichern!
  const { error } = await _supabase.from("live_matches").insert([
    {
      room_code: roomCode,
      player1_name: myOnlineName,
      // Zweiter Weg, auf dem ein Raum entsteht (Herausforderung aus der
      // Freundesliste) - deshalb hier dieselbe Zeile wie in
      // game-501.js createOnlineGame. Fehlt sie an EINER der beiden
      // Stellen, sind genau die darueber angelegten Raeume ungeschuetzt,
      // und niemand kaeme darauf, dass es am Einstiegsweg liegt.
      //
      // Eine Herausforderung setzt eine Anmeldung voraus (man braucht
      // Freunde), currentUser ist hier also immer gesetzt. Der
      // Sicherheitshalt bleibt trotzdem stehen.
      host_user_id: !isGuest && currentUser ? currentUser.id : null,
      status: "waiting",
      best_of_legs: legs, // <--- HIER übergeben wir dein Setting!
      starting_score: startScore,
      player1_score: startScore,
      player2_score: startScore,
      last_action: t("js.friends.027"),
    },
  ]);

  if (error) return showToast(t("js.friends.005") + error.message, "error");

  // 4. Globale Spiel-Parameter setzen
  currentRoomCode = roomCode;
  amIPlayer1 = true;
  isLocal501 = false;
  currentAppMode = mode;
  bestOfLegs = legs; // Ganz wichtig für den Start
  startingScore501 = startScore;

  // 5. Ab in die Online Lobby
  openOnlineLobby(roomCode, myOnlineName, null, true);
  if (typeof listenForOpponent === "function") listenForOpponent(roomCode);

  // 6. Push-Nachricht an den Gegner mit allen Infos
  const targetChannel = _supabase.channel(`user-${targetUserId}`);
  targetChannel.subscribe((status) => {
    if (status === "SUBSCRIBED") {
      targetChannel.send({
        type: "broadcast",
        event: "game-challenge",
        payload: {
          senderId: currentUser.id,
          senderName: myOnlineName,
          roomCode: roomCode,
          mode: mode,
          legs: legs, // <-- Wir sagen dem Gegner, wie viele Legs wir wollen
          startScore: startScore,
        },
      });
      showToast(tf("js.friends.035", { p1: targetUserName }), "success");
      setTimeout(() => {
        _supabase.removeChannel(targetChannel);
      }, 1500);
    }
  });
}

// 2. Der Empfänger bekommt die Anfrage
function handleIncomingChallenge(data) {
  const textEl = document.getElementById("generic-confirm-text");
  const btnYes = document.getElementById("generic-confirm-yes-btn");
  const modal = document.getElementById("generic-confirm-modal");

  // NEU: Den Modus und die Legs elegant formatieren
  const modeText =
    data.mode === "501" ? tf("js.friends.011", { p1: data.startScore || 501 }) : data.mode;
  const legsText = data.legs ? tf("js.friends.036", { p1: data.legs }) : "";

  // NEU: Anzeige aktualisieren
  // Ganzer Satz als EIN Schluessel samt Auszeichnung: Im Englischen steht
  // das Verb an anderer Stelle ("challenges you to ..."), eine Zerlegung in
  // Fragmente waere nicht uebersetzbar.
  textEl.innerHTML = tf("js.friends.herausforderung", {
    p1: data.senderName,
    p2: modeText,
    p3: legsText,
  });

  btnYes.innerText = t("js.friends.028");
  btnYes.style.background = "var(--accent-green)";
  btnYes.style.color = "black";

  // JA-Klick
  btnYes.onclick = () => {
    modal.style.display = "none";

    if (data.startScore) startingScore501 = data.startScore;

    // Ins Input Feld eintragen und direkt den Beitritt triggern
    const joinInput = document.getElementById("join-room-code");
    if (joinInput) joinInput.value = data.roomCode;
    joinOnlineGame();
  };

  // NEIN-Klick (Wir greifen uns den Abbrechen-Button)
  const btnCancel = textEl.nextElementSibling.querySelector(".reset");
  const originalCancel = btnCancel.onclick; // Backup

  btnCancel.onclick = () => {
    modal.style.display = "none";
    // Sende Absage zurück
    const senderChannel = _supabase.channel(`user-${data.senderId}`);
    senderChannel.subscribe((status) => {
      if (status === "SUBSCRIBED") {
        senderChannel.send({
          type: "broadcast",
          event: "challenge-declined",
          payload: { declinerName: myOnlineName },
        });
        setTimeout(() => {
          _supabase.removeChannel(senderChannel);
        }, 1500);
      }
    });
    btnCancel.onclick = originalCancel; // Reset für andere Modals
  };

  modal.style.display = "flex";
  modal.style.zIndex = "100000";
}

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
// ==========================================
// FREUNDE-STATISTIK-MODAL (neu 07.08.2026, Aufgabe 3)
//
// Klick auf einen Freund zeigt die Hauptstats in einem kleinen Modal.
// Die Kennzahlen kommen aus den wiederverwendbaren Bausteinen in
// profile.js (buildProfileStats) - hier wird nur AUSGEWAEHLT, was als
// "Hauptstat" gilt. Neue Kennzahlen ergaenzen = eine Zeile in dieser
// Liste (modular, keine zweite Berechnungslogik).
// ==========================================
const FRIEND_STATS_SECTIONS = [
  {
    title: "501",
    tabKey: "501",
    table: "stats_501",
    pick: [t("js.friends.029"), t("js.friends.030"), "180er", t("js.friends.031"), t("js.friends.012")],
  },
  {
    title: "Secure Darts",
    tabKey: "secure",
    table: "stats_secure",
    pick: [t("js.friends.013"), t("js.friends.032"), t("js.friends.033")],
  },
];

async function openFriendStats(userId, encodedName, encodedAvatar) {
  const modal = document.getElementById("friend-stats-modal");
  const nameEl = document.getElementById("friend-stats-name");
  const avatarEl = document.getElementById("friend-stats-avatar");
  const body = document.getElementById("friend-stats-body");
  if (!modal || !body) return;

  const name = decodeURIComponent(encodedName || "");
  const avatar = decodeURIComponent(encodedAvatar || "");

  if (nameEl) nameEl.textContent = name || t("js.app.009");
  if (avatarEl) {
    // Avatar kommt aus der profiles-Tabelle (einzige Quelle der Wahrheit,
    // siehe Profilbild-Analyse Aufgabe 4) - die Freundesliste hat ihn
    // bereits von dort geladen und reicht ihn hier nur durch.
    avatarEl.src =
      avatar ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(name)}`;
  }
  body.innerHTML =
    typeof skeletonKpiHtml === "function"
      ? skeletonKpiHtml(6)
      : `<p style="color: var(--text-muted)">${t("js.friends.014")}</p>`;
  modal.style.display = "flex";

  // Beide Tabellen parallel laden; eine fehlende Zeile ist kein Fehler
  // (der Freund hat den Modus dann einfach noch nie gespielt).
  const results = await Promise.all(
    FRIEND_STATS_SECTIONS.map((section) =>
      _supabase
        .from(section.table)
        .select("*")
        .eq("user_id", userId)
        .maybeSingle()
        .then(({ data }) => data)
        .catch(() => null),
    ),
  );

  // Wurde das Modal inzwischen geschlossen, nichts mehr rendern
  if (modal.style.display === "none") return;

  let html = "";
  let hasAny = false;
  FRIEND_STATS_SECTIONS.forEach((section, i) => {
    const data = results[i];
    if (!data) return;
    const all =
      typeof buildProfileStats === "function"
        ? buildProfileStats(section.tabKey, data).kpis
        : [];
    const kpis = section.pick
      .map((label) => all.find((k) => k.label === label))
      .filter(Boolean);
    if (!kpis.length) return;
    hasAny = true;
    html += `<div class="friend-stats-section-title">${section.title}</div>`;
    html += '<div class="friend-stats-grid">';
    kpis.forEach((k) => {
      html += `
        <div class="friend-stats-kpi">
          <div class="friend-stats-value"${k.accent ? ` style="color:${k.accent}"` : ""}>${k.value}</div>
          <div class="friend-stats-label">${k.label}</div>
        </div>`;
    });
    html += "</div>";
  });

  body.innerHTML =
    hasAny && html
      ? html
      : `<p style="color: var(--text-muted)">${t("js.friends.015")}</p>`;
}

function closeFriendStats() {
  const modal = document.getElementById("friend-stats-modal");
  if (modal) modal.style.display = "none";
}

Object.assign(window, {
  initPresence,
  switchFriendsTab,
  searchPlayers,
  sendFriendRequestById,
  fetchAndRenderFriends,
  refreshHomeFriendsPanel,
  toggleFriendsPanel,
  initNotifications,
  openFriendStats,
  closeFriendStats,
  // Vier tote Knoepfe der Freundesliste, alle per inline onclick im
  // erzeugten Markup und alle nur im Modul-Scope definiert:
  //   openChallengeSetup  -> "Spielen"        (friends.js:417)
  //   respondToRequest    -> "Annehmen"       (friends.js:443)
  //   removeFriend        -> Loeschen/Ablehnen/Abbrechen (422, 444, 456)
  // Ohne respondToRequest liess sich keine Freundschaftsanfrage annehmen -
  // die Freundesliste war damit als Ganzes unbenutzbar.
  openChallengeSetup,
  respondToRequest,
  removeFriend,
});
